import { WebAPI } from './web-api';
import { WebApiSettings } from './types';

export {
  WebAPI,
  WebApiSettings
};
